const hasOwnProperty = (object, key) => {
  return Object.prototype.hasOwnProperty.call(object, key);
};
export {
  hasOwnProperty as h
};
//# sourceMappingURL=has-own-property.js.map
